import { useRef, useState, useEffect } from "react";
import { changeSoundScreenAudio } from '../../src/redux/appConfigSlice';
import { useDispatch } from 'react-redux';
import { pushFaroEvent } from '../faroSession';

const AudioPlayer = (src: string) => {
  const audioRef = useRef<HTMLAudioElement>(new Audio(src));
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const dispatch = useDispatch();
  //   const [volume, setVolume] = useState(1)  --commented line

  useEffect(() => {
    const audio = audioRef.current;
    const handleEnded = () => {
      setIsPlaying(false);
      pushFaroEvent('audio_playback_ended', { source: 'audio_player' });
    };
    const handleLoadedMetadata = () => {
      if(audio){
        setDuration(Math.round(audio.duration));
      }
      pushFaroEvent('audio_metadata_loaded', { duration: String(audio.duration) });
    }
    audio.addEventListener("ended", handleEnded);
    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    return () => {
      audio.removeEventListener("ended", handleEnded);
      audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    };
  }, []);

  const playAudio = () => {
    audioRef.current.play();
    setIsPlaying(true);
    pushFaroEvent('audio_playback_started', { source: 'audio_player' });
     dispatch(changeSoundScreenAudio(true));
  };
  const audioRoundedDuration = () => {
    return isNaN(duration) ? 0 : duration;
  }

  return {
    playAudio,
    // pauseAudio,
    // stopAudio,
    // changeVolume,
    isPlaying,
    // volume,
    // audioRef,
    audioRoundedDuration
  };
};
export default AudioPlayer;
